import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import AddBook from "./pages/BookStore/AddBook";
import BookContainer from "./pages/BookStore/BookContainer";
import EditBook from "./pages/BookStore/EditBook";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<BookContainer />} />
          <Route path="/AddBook" element={<AddBook />} />
          <Route
            path="/EditBook/:bookId"
            element={<EditBook />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
